/**
 * @Author: 韩祺涛
 * @Date: 2023-03-02
 * @Project: 杭氧客户现场使用
 */
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'
// 获取设备类型
export function getDeviceType (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/query',
    method: 'GET',
    params: parameter
  })
}
// 获取树形设备类型
export function getTreeDeviceType (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/treequery',
    method: 'GET',
    params: parameter
  })
}
// 参数类型删除
export function deleteParam (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/param/deleteParam',
    method: 'DELETE',
    params: parameter
  })
}
// 获取设备参数列表数据
export function getDeviceParameterList(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/params',
    method: 'GET',
    params: parameter
  })
}
// 新增或者编辑设备参数数据
export function addOrEditDeviceParameter(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/param',
    method: 'POST',
    data: parameter
  })
}
// 校验此参数是否被使用
export function checkExistenceValue(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/param/checkExistenceValue',
    method: 'GET',
    params: parameter
  })
}
// 校验自定义参数/基础参数/特性 是否配置台账展示
export function checkFieldDelete(parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/type/checkFieldDelete',
    method: 'GET',
    params: parameter
  })
}